module.exports = __webpack_public_path__ + "static/media/fleishman-is-in-trouble.c634ed0e.jpg";